// @noflow
class BitmovinDelegate {
  constructor(player) {
    this._player = player;
    this._subscriptions = {};
  }

  on(eventType, fn) {
    if (this._player.playerView) {
      this._player.playerView.on(eventType, fn);
    }
    this._registerListener(eventType, fn);
  }

  _registerListener(eventType, fn) {
    if (this._subscriptions[eventType]) {
      this._subscriptions[eventType].push(fn);
    } else {
      this._subscriptions[eventType] = [fn];
    }
  }

  revokeAllSubscriptions() {
    Object.keys(this._subscriptions).forEach(event => {
      this._subscriptions[event].forEach(handler => this.off(event, handler));
    });
  }

  off(eventType, fn) {
    this._player.playerView.off(eventType, fn);
  }

  get playerVersion() {
    return this._player?.playerView?.version;
  }

  get streamProtocol() {
    const supportedTech = this._player?.playerView?.getSupportedTech();
    return supportedTech.length ? supportedTech[0].streaming : null;
  }

  get sourceType() {
    return this._player?.props?.sourceType;
  }

  async streamDrm() {
    const res = await this._player?.playerView?.getSupportedDRM();
    return res.length ? res[0] : null;
  }

  get streamUrl() {
    const sources = this._player?.playerView?.getSource();
    return sources && sources[this.streamProtocol] ? sources[this.streamProtocol] : null;
  }

  get playerName() {
    return this._player?.playerView?.getPlayerType();
  }

  get userId() {
    return this._player?.props?.viewer?.euid;
  }

  get videoElement() {
    return this._player?.playerView?.getVideoElement();
  }

  get currentTime() {
    return this._player?.playerView?.getCurrentTime();
  }

  get videoData() {
    return this._player?.playerView?.getPlaybackVideoData();
  }

  get droppedFramesCount() {
    return this._player?.playerView?.getDroppedVideoFrames();
  }

  get totalStalledTime() {
    return this._player?.playerView?.getTotalStalledTime() * 1000;
  }

  get duration() {
    return this._player?.playerView?.getDuration();
  }

  get bestBitRates() {
    if (
      !this._player?.playerView?.getAvailableVideoQualities().length ||
      !this._player?.playerView?.getAvailableAudioQualities().length
    ) {
      return {
        video: 0,
        audio: 0,
      };
    }
    return {
      video: this._player?.playerView?.getAvailableVideoQualities().pop().bitrate,
      audio: this._player?.playerView?.getAvailableAudioQualities().pop().bitrate,
    };
  }
}

export default BitmovinDelegate;
